class ProductLabels extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    if (!this.els.item?.exists) return

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleClick = this.handleClick.bind(this)

    this.els.item.elements.forEach((item) => {
      this.listeners.add(item, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(item, 'mouseleave', this.handleMouseLeave)
      this.listeners.add(item, 'click', this.handleClick)
    })
  }

  handleClick (event) {
    if (!this.hasAttribute('data-track-colour-swatch')) return

    const item = event.currentTarget
    const input = item.querySelector('input')

    if (input?.checked) return

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({
      event: 'pdp_swatch_click',
      target_text: item.dataset.name,
    })
  }

  handleMouseEnter (e) {
    this.els.name.element.textContent = e.currentTarget.dataset.name
  }

  handleMouseLeave () {
    this.els.name.element.textContent = this.els.name.element.dataset.default
  }
}

if (!customElements.get('product-labels')) {
  customElements.define('product-labels', ProductLabels)
}
